import { render } from "./Tabbar-Item.vue?vue&type=template&id=02cb9079"
import script from "./Tabbar-Item.vue?vue&type=script&lang=js"
export * from "./Tabbar-Item.vue?vue&type=script&lang=js"

import "./Tabbar-Item.vue?vue&type=style&index=0&id=02cb9079&lang=css"

import exportComponent from "/Users/hlw/Documents/HBuilderProjects/menhu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__